import RatingInfoButton from '@/pages/artwork/content-section/socials/artwork-ratings/components/RatingInfoButton';
import RatingBarDisplayer from '@/shared-components/inputs/components/RatingBarDisplayer';
import Text from '@/shared-components/text/components/Text';

import './styles/MyRating.css';

export default function MyRating({ category, text, myRating, averageRating }) {
  return (
    <>
      <div className="artwork-ratings-my-rating__container">
        <div className="artwork-ratings-my-rating__category-row">
          <Text className="artwork-ratings-my-rating__category font-size-large">
            {category}
          </Text>

          <RatingInfoButton category={category} text={text} />
        </div>

        <div className="artwork-ratings-my-rating__rating-bar-container">
          <RatingBarDisplayer 
            username="Average" 
            userRating={averageRating} 
            myRating={myRating} 
            ignoreRightOverflow 
            includeGuide
          />
        </div>
      </div>
    </>
  );
}
